import * as React from "react"
import Seo from "../../components/seo"
import { EwalletFuelSolutionsMeta } from "../../data/metaData"
import Header from "../../components/header"
import Footer from "../../components/footer"
import RequestQuote from "../../components/request-a-quote"
import CaseStudiesList from "../../components/case-studies-list"
import BlogList from "../../components/blog-list"
import { Container, Row, Col } from "react-bootstrap"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import LazyLoad from "react-lazy-load"

const schemaOrgJSONLD1 =
{
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "WebPage",
      "@id": "https://www.digipay.guru/mobile-money/ewallet-fuel-solutions/",
      "url": "https://www.digipay.guru/mobile-money/ewallet-fuel-solutions/",
      "name": "eWallet Fuel Solutions, Mobile Wallet for Fuel Retail",
      "isPartOf": {
        "@id": "https://www.digipay.guru/#website"
      },
      "description": "eWallet fuel payment solution to automate, and make the fueling & payment process quick and easy. Cashless fuel retail solution with API-driven mobile wallets.",
      "breadcrumb": {
        "@id": "https://www.digipay.guru/mobile-money/ewallet-fuel-solutions/#breadcrumb"
      },
      "inLanguage": "en-US",
      "potentialAction": [
        {
          "@type": "ReadAction",
          "target": [
            "https://www.digipay.guru/mobile-money/ewallet-fuel-solutions/"
          ]
        }
      ]
    },
    {
      "@type": "BreadcrumbList",
      "@id": "https://www.digipay.guru/mobile-money/ewallet-fuel-solutions/#breadcrumb",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "eWallet Fuel Solutions solution",
          "item": "https://www.digipay.guru/"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "Mobile Wallet for Fuel Retail"
        }
      ]
    },
    {
      "@type": "WebSite",
      "@id": "https://www.digipay.guru/#website",
      "url": "https://www.digipay.guru/",
      "name": "Digipay.Guru",
      "description": "Digipay.Guru",
      "potentialAction": [
        {
          "@type": "SearchAction",
          "target": {
            "@type": "EntryPoint",
            "urlTemplate": "https://www.digipay.guru/?s={search_term_string}"
          },
          "query-input": "required name=search_term_string"
        }
      ],
      "inLanguage": "en-US"
    }
  ]
}

export const Head = () => (
  <>
    <Seo
      title={EwalletFuelSolutionsMeta.metaTitle}
      description={EwalletFuelSolutionsMeta.metaDescription}
      ogImage={EwalletFuelSolutionsMeta.ogImage}
      twitterImage={EwalletFuelSolutionsMeta.twitterImage}
    />
    <script type="application/ld+json">
      {JSON.stringify(schemaOrgJSONLD1)}
    </script>
  </>
)

// markup
const EwalletFuelSolutions = () => {

  const FuelRetailBanner = "../../images/fuel-retail-banner.png"
  const FuelRetailDigitize = "../../images/fuel-retail-digitize.png"

  const ChallengesFaced = [
    {
      title: "Prolonged waiting times",
      desc: "One of the major problems that customers face is that they have to wait in long queues which eats up a lot of their time and makes them frustrated and annoyed.",
      iconName: "prolonged",
      iconBgColor: "icon-color1"
    },
    {
      title: "Lack of customer retention strategy",
      desc: "Customer retention is at a major risk as many customers would avoid coming to fuel stations with long queues. Instead, they would prefer a station with little or no queue.",
      iconName: "lack-of-customer",
      iconBgColor: "icon-color2"
    },
    {
      title: "Rush hour challenges",
      desc: "Serving during the rush hours gets challenging for the fuel stations as they’re under pressure to serve as many customers as possible ensuring that they don’t lose out on any of them.",
      iconName: "rush-hour",
      iconBgColor: "icon-color3"
    },
    {
      title: "Inconvenient payment methods",
      desc: "Customers must have their wallets handy for the payment; if they forget their cash/cards, they won’t be able to fill their tanks leading to further disappointment and frustrations.",
      iconName: "inconvenient",
      iconBgColor: "icon-color4"
    },
    {
      title: "Lack of trust and transparency",
      desc: "Many times, customers don’t trust the fuel stations and are always in the suspicion if they would be cheated and charged more than the amount of fuel they filled.",
      iconName: "lack-of-trust",
      iconBgColor: "icon-color5"
    },
    {
      title: "Fuel expenses tracking hassles",
      desc: "Tracking of fuel expenses is a tedious task for the customers as they need to manually maintain a record of each transaction for every vehicle that they own.",
      iconName: "fuel-expenses",
      iconBgColor: "icon-color6"
    }
  ]
  const fuellingExperience = [
    {
      iconName: "convenience",
      title: "Convenience",
      desc: "Customers enjoy the utmost convenience of paying for fuel by using mobile wallet without getting out of the car."
    },
    {
      iconName: "track-fuel",
      title: "Track fuel expenses",
      desc: "Customers can seamlessly track and manage the fuel expenses of a various number of vehicles that they own."
    },
    {
      iconName: "online-services",
      title: "Online services",
      desc: "The online services are far more convenient than the offline services as it saves user’s time and energy."
    },
    {
      iconName: "cashbacks",
      title: "Cashbacks, promos, and loyalty",
      desc: "Customers get loyalty benefits along with added benefit of cashbacks for purchasing tickets, sending gifts, etc."
    },
    {
      iconName: "transparency",
      title: "100% transparency",
      desc: "With DigiPay’s ewallet fuel solutions, customers get complete transparency on the quantity of the fuel to be filled."
    },
    {
      iconName: "multiple-payment",
      title: "Multiple payment modes",
      desc: "Customers can choose from the various payment modes, such as, credit card, bank account or e-money in the wallet."
    }
  ]

  const experienceSwift = [
    {
      shadowBox: [
        {
          iconName: "automated",
          title: "Automated fuelling",
          desc: "DigiPay’s ewallet fuel app offers real time updates to both customers and retailers, providing complete control over the fuelling process."
        }
      ]
    },
    {
      minus: "mt-n55",
      shadowBox: [
        {
          iconName: "quantity-assurance",
          title: "Quantity assurance",
          desc: "Your customer doesn’t need to see the '0' at the meter before fuelling as they can control the fuelling through DigiPay’s Fuel Wallet App."
        },
        {
          iconName: "loyalty",
          title: "Loyalty and amenities",
          desc: "Reward users as per their transactions over the app. Provide multiple amenities for customer convenience."
        }
      ]
    },
    {
      minus: "mt-n310",
      shadowBox: [
        {
          iconName: "cashless",
          title: "Cashless transactions",
          desc: "Offer end-to-end transactions via the DigiPay’s ewallet fuel system, which automatically processes payments from the user's account."
        },
        {
          iconName: "e-statements",
          title: "E-statements & E-invoices",
          desc: "After fuelling in, users will receive the e-invoice. Moreover, the application will also maintain statements of every purchase."
        },
        {
          iconName: "track-expenses",
          title: "Track Expenses",
          desc: "As all the fuel expenses are automatically maintained, the customers can track all the expenses per vehicle."
        }
      ]
    },
    {
      minus: "mt-n200",
      shadowBox: [
        {
          iconName: "manage-multiple",
          title: "Manage multiple vehicles",
          desc: "DigiPay’s ewallet fuel solution also allows your customers to manage fuelling of multiple vehicles from a single app."
        },
        {
          iconName: "find-nearby",
          title: "Find nearby fuel stations",
          desc: "Customers can find the list of nearby fuel stations and can get the direction to reach them respectively."
        },
      ]
    }
  ]

  const businessForward = [
    {
      title: "Speed up fuelling service",
      desc: "Attract new customers by curtailing the long queues which will ultimately speed up the fuel fuelling service.",
      iconLine: "icon-left-line1",
      iconName: "speed-up-fuelling",
    },
    {
      title: "Efficient rush hour management",
      desc: "Rush hours can be managed and served better which eventually increases the overall sales.",
      iconLine: "icon-left-line2",
      iconName: "efficient-rush",
    },
    {
      title: "Utmost customer convenience",
      desc: "Offer rich customer fuelling experience as they can order for fuel online along with fuelling their car without getting out of it.",
      iconLine: "icon-left-line3",
      iconName: "utmost-customer",
    },
    {
      title: "Loyalty programs",
      desc: "Retain your customers by creating a rewarding loyalty program based on their app usage and activities therein.",
      iconLine: "icon-left-line4",
      iconName: "loyalty-programs",
    },
    {
      title: "Increase revenue",
      desc: "Increase your overall revenue with wallet’s additional earnings, new customer base, and retained customers.",
      iconLine: "icon-left-line5",
      iconName: "increase-revenue",
    },
    {
      title: "Visibility & accessibility",
      desc: "Make all your fuel stations easily visible and accessible to all the customers via Digipay’s ewallet fuel solution.",
      iconLine: "icon-left-line6",
      iconName: "visibility-accessibility",
    }
  ]

  return (
    <>
      {/* <SSRProvider> */}
      <div className="wrapper">
        <Header />
        <main className="main-container">
          <section
            className="section banner-section d-md-flex align-items-center"
            style={{ backgroundColor: "#a9ead6" }}
          >
            <Container className="py-4">
              <Row className="align-items-center g-5">
                <Col lg={5}>
                  <div className="banner-content">
                    <h1 className="title fw-semibold mb-4-lg">
                      An ultimate mobile wallet solution for fuel retailers
                    </h1>
                    <Link
                      to="/contact-us"
                      className="btn btn-lg btn-primary-theme btn-240 mt-4 mt-lg-5"
                    >
                      <span>Request a Demo</span>
                    </Link>
                  </div>
                </Col>
                <Col lg={7} className="text-center">
                  <LazyLoad offsetVertical={1000}>
                    <StaticImage
                      loading="lazy"
                      src={FuelRetailBanner}
                      width={739}
                      height={451}
                      alt="Fuel Retail Banner"
                    />
                  </LazyLoad>
                </Col>
              </Row>
            </Container>
          </section>
          <section className="section">
            <Container className="py-5">
              <Row className="g-5 align-items-center">
                <Col lg={6} xxl={5} className="mx-auto order-lg-2">
                  <div className="section-title">
                    <h2 className="heading fw-semibold mb-4">
                      How a fuel retail solution works?
                    </h2>
                    <p className="lead">
                      An advanced cashless fuel retail solution helps you to
                      redefine the fuelling experience of your customers. With
                      this solution in place, you can make your fuelling
                      process fast, convenient, and secure. Have a look at the
                      below video where we have explained in detail about the
                      working mechanism of this solution along with its
                      benefits and advantages.
                    </p>
                  </div>
                </Col>
                <Col lg={6}>
                  <div className="ratio ratio-16x9">
                    <iframe
                      className="lazyload"
                      loading="lazy"
                      width="100%"
                      height="500"
                      src="https://www.youtube.com/embed/LspZnGGC9n4"
                      title="YouTube video player"
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    ></iframe>
                  </div>
                </Col>
              </Row>
            </Container>
          </section>
          <section className="section bg-light">
            <Container className="py-5">
              <Row className="g-5">
                <Col lg={6}>
                  <div className="section-title sticky-section">
                    <h2 className="heading fw-semibold mb-4">
                      Challenges faced by users at fuel stations
                    </h2>
                    <p className="lead">
                      Users have to go through a cluster of challenges while
                      fuelling their vehicles at the fuel stations. Some of
                      these challenges are mentioned below.
                    </p>
                  </div>
                </Col>
                <Col lg={6}>
                  {ChallengesFaced?.map((item, index) => (
                    <div key={index} className="shadow-box mb-4 py-5 shadow-none">
                      <div className="left-icon-box d-flex align-items-start">
                        <div className="icon pe-4 mt-n20">
                          <i className={`fuel-retail-sprite-icon icon-size-70 icon-fill ${item.iconName} ${item.iconBgColor}`}></i>
                        </div>
                        <div>
                          <h3 className="heading h4 mb-3">{item.title}</h3>
                          <p className="mb-0 font-size-16">{item.desc}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </Col>
              </Row>
            </Container>
          </section>
          <section className="section">
            <Container className="py-5">
              <Row className="g-5 align-items-center">
                <Col lg={6} className="order-lg-2">
                  <div className="section-title">
                    <h2 className="heading fw-semibold mb-4">
                      Digitize your fuel retail business with DigiPay
                    </h2>
                    <p>
                      DigiPay comes with a mobile wallet for fuel retail that
                      provides quick, convenient, and secure payment for all
                      the customers. It leverages the latest digital
                      technologies to ensure incredible customer experience on
                      every visit. It deals with customer anxiety,
                      inconveniences and stress points directly by ensuring
                      that customers can drive in, refuel and drive out
                      without any hassle.
                    </p>
                    <p>
                      It allows individuals and corporates to pre-set the
                      quantity of fuel they want filled in a vehicle, resets
                      the fuel gauge to zero, and ensures that they receive
                      what they have paid for. Through the DigiPay wallet, the
                      entire transaction is managed digitally, via secure
                      payments that allow the user to drive out without having
                      to reach for cash or cards.
                    </p>
                  </div>
                </Col>
                <Col lg={6} className="text-center">
                  <LazyLoad offsetVertical={1000}>
                    <StaticImage
                      loading="lazy"
                      src={FuelRetailDigitize}
                      width={521}
                      height={621}
                      alt="Fuel Retail Digitize"
                    />
                  </LazyLoad>
                </Col>
              </Row>
            </Container>
          </section>

          <section className="section bg-light position-relative">
            <div className="dot-styled"></div>
            <Container className="py-5">
              <div className="white-shadow-box0">
                <div className="w-75 mx-auto text-center">
                  <div className="section-title mb-5 pb-1">
                    <h2 className="heading fw-semibold mb-4">
                      Please your customers with rich fuelling experience
                    </h2>
                    <p className="lead">
                      DigiPay is not only a one-stop solution to your fuel
                      business hassles, but also a solution for problems faced
                      by all your customers. Below is the list of perks that
                      our solution provides to your customers.
                    </p>
                  </div>
                </div>
                <Row className="g-5" xs={1} lg={3}>
                  {fuellingExperience?.map((item, index) => (
                    <Col key={index}>
                      <div className="center-icon-box text-center">
                        <div className="icon mb-3">
                          <i className={`icon-size-100 fuel-retail-sprite-icon ${item.iconName}`}></i>
                        </div>
                        <h3 className="heading font-size-24 mb-4">{item.title}</h3>
                        <p className="mb-0">{item.desc}</p>
                      </div>
                    </Col>
                  ))}
                </Row>
              </div>
            </Container>
          </section>

          <section className="section bg-white position-relative">
            <Container className="py-5">
              <div className="section-title mb-5 pb-1 pb-lg-5 w-50">
                <h2 className="heading fw-semibold mb-4">
                  Make your user’s fuelling experience swift, comfortable, and
                  safe
                </h2>
                <p className="lead w-75">
                  DigiPay is a feature rich application that provides your
                  customers with a smooth fuelling experience. Some of the
                  advanced features are mentioned below.
                </p>
              </div>
              <Row className="g-4" xs={1} lg={4}>
                {experienceSwift?.map((item, index) => (
                  <Col key={index} className={`${item.minus}`}>
                    {item.shadowBox?.map((item, index) => (
                      <div key={index} className="shadow-box center-icon-box text-center mb-4">
                        <div className="icon mb-3">
                          <i className={`fuel-retail-sprite-icon icon-size-70 ${item.iconName}`}></i>
                        </div>
                        <h3 className="heading h5 mb-3">{item.title}</h3>
                        <div className="overlay">
                          <p className="font-size-16 mb-0">{item.desc}</p>
                        </div>
                      </div>
                    ))}
                  </Col>
                ))}
              </Row>
            </Container>
          </section>

          <section className="section position-relative bg-light2">
            <Container className="py-5">
              <div className="white-shadow-box0">
                <div className="w-75">
                  <div className="section-title mb-5 pb-1">
                    <h2 className="heading fw-semibold mb-4">
                      Take your fuel retail business forward
                    </h2>
                    <p className="lead">
                      The advanced features of DigiPay makes the fuelling
                      process streamlined and swift. Due to which you can
                      achieve many feats at once. Below is the list of things
                      that you can achieve with DigiPay.
                    </p>
                  </div>
                </div>
                <Row className="g-5" xs={1} lg={3}>
                  {businessForward?.map((item, index) => (
                    <Col key={index}>
                      <div className={`top-left-icon-border-box position-relative ps-4 ${item.iconLine}`}>
                        <div className="icon mb-3">
                          <i className={`fuel-retail-sprite-icon icon-size-50 ${item.iconName}`}></i>
                        </div>
                        <h3 className="heading h5 mb-3">{item.title}</h3>
                        <p className="mb-0 font-size-16">{item.desc}</p>
                      </div>
                    </Col>
                  ))}
                </Row>
              </div>
            </Container>
          </section>
          <CaseStudiesList />
          <BlogList />
          <RequestQuote />
        </main>
        <Footer />
      </div>
      {/* </SSRProvider> */}
    </>
  )
}

export default EwalletFuelSolutions
